import { useUpdatePrestation } from '@/api/prestations/prestations.mutations';
import type { PrestationDetail } from '@/api/prestations/prestations.types';
import { Checkbox } from '@/components/Checkbox';

interface PrestationJustificatifSettingProps {
  prestation: Pick<PrestationDetail, 'id' | 'requiresJustificatif'>;
}

export function PrestationJustificatifSetting({ prestation }: PrestationJustificatifSettingProps) {
  const updatePrestation = useUpdatePrestation(prestation.id);

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-lg font-medium">Justificatifs</h3>
      <label htmlFor="prestation-requires-justificatif" className="flex items-center gap-2 text-sm">
        <Checkbox
          id="prestation-requires-justificatif"
          checked={prestation.requiresJustificatif}
          disabled={updatePrestation.isPending}
          onCheckedChange={(checked) =>
            updatePrestation.mutate({ requiresJustificatif: checked === true })
          }
        />
        Justificatif obligatoire
      </label>
      <p className="text-sm text-gray-500">
        Un dossier sans justificatif est signalé « Justificatif manquant ». L'inscription et le
        règlement restent possibles en attendant la pièce.
      </p>
    </div>
  );
}
